import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  BY,
  ShipmentParams,
  SHIPMENTS_BY_DAY, SHIPMENTS_BY_MONTH,
  SHIPMENTS_BY_WEEK, SHIPMENTS_BY_YEAR,
  ShipmentSliceType,
  ShipmentsWithBillParams
} from './Types';
import Shipment from "../../Models/Shipment";
import Receiver from "../../Models/Receiver";
import PickupTypes from "../../Models/PickupTypes";
import moment from "moment";

const initialState: ShipmentSliceType = {
  shipments: [],
  deliveredShipment: [],
  [SHIPMENTS_BY_DAY]: [],
  [SHIPMENTS_BY_WEEK]: [],
  [SHIPMENTS_BY_MONTH]: [],
  [SHIPMENTS_BY_YEAR]: [],
};


const ShipmentSlice = createSlice({
  name: "Shipment",
  initialState,
  reducers: {
    getShipments(status: ShipmentSliceType, {payload}: PayloadAction<ShipmentParams>) {
    },
    setShipments(status: ShipmentSliceType, {payload}: PayloadAction<Shipment[]>) {
      status.shipments = payload;
      const deliveredShipments = payload?.filter(s => s.status === PickupTypes.SHIPMENT_DELIVERED);
      status.deliveredShipment = deliveredShipments?.map((shipment) => {
          return {
            id: shipment?._KEY,
            receiver: (shipment?.receiver as Receiver)?.name,
            pickup_date: moment(shipment?.pickup_date).format('DD-MM-yyyy'),
            delivery_date: moment(shipment?.delivery_date).format('DD-MM-yyyy'),
            total_value: `$${shipment.total_value}` ,
          };
        }
      );
    },
    getShipmentsWithBill(state, {payload}: PayloadAction<ShipmentsWithBillParams>) {
    },
    setShipmentsWithBill(state, {payload}: PayloadAction<{ by: BY, shipments: Shipment[] }>) {
      state[payload.by] = payload.shipments;
    },
  }
});

export const ShipmentActions = ShipmentSlice.actions;

export default ShipmentSlice.reducer;
